import { request } from '../client';

export const listAddresses = () => request('/addresses');

export const createAddress = (payload) => request('/addresses', { method: 'POST', body: payload });

export const updateAddress = (id, payload) => request(`/addresses/${id}`, { method: 'PATCH', body: payload });

export const setDefaultAddress = (id) => request(`/addresses/${id}/default`, { method: 'PATCH' });

export const deleteAddress = (id) => request(`/addresses/${id}`, { method: 'DELETE' });
